














import { Vue, Component, Prop } from 'vue-property-decorator';
import ModalLinePrimary from '@/components/Modal/ModalLinePrimary.vue';
import ModalLineSecondary from '@/components/Modal/ModalLineSecondary.vue';
import SvgIcon from '@/components/SvgIcon/SvgIcon.vue';

@Component({
    components: {
        ModalLinePrimary,
        ModalLineSecondary,
        SvgIcon,
    },
})
export default class GenplanModalLinkItem extends Vue {
    /**
     *
     */
    @Prop()
    public readonly href!: string;
    /**
     *
     */
    @Prop()
    public readonly linePrimary!: string;
    /**
     *
     */
    @Prop()
    public readonly lineSecondary!: string;
}
